export const HTTP_TIMEOUT_LIMIT = 30_000

/** 인증·검증·상품 조회처럼 사용자가 결과를 기다리는 요청은 30초를 다 기다리지 않고 빨리 실패시킨다. */
export const HTTP_SHORT_TIMEOUT_LIMIT = 10_000

export const HTTP_USER_AGENT = 'MacarongWEB'

export const HTTP_ERROR_MESSAGE = {
  NETWORK: '네트워크 오류가 발생했습니다.',
  TIMEOUT: '요청 시간이 초과되었습니다.',
} as const

export const UNKNOWN_VALUE = 'unknown'

export const isServer = typeof window === 'undefined'

export const isDev = process.env.NODE_ENV !== 'production'

export const isDevServer = isDev && isServer
